import Vue from "vue"
import i18n from '@/i18n'
Vue.filter('strategyStatusFilter', (value) => {
  switch (value) {
    case 0:
      return '全部'
    case 1:
      return i18n.t('HT.advancedService.status.inEffect')
    case 2:
      return i18n.t('HT.advancedService.status.pending')
    case 3:
      return i18n.t('HT.advancedService.status.completed')
  }
})